import { Directive, HostListener, ElementRef, Renderer2 } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';

@Directive({
  selector: '[shared-title-if-ellipse]',
  standalone: false,
  hostDirectives: [MatTooltip],
})
export class TitleIfEllipseDirective {
  constructor(
    private elementRef: ElementRef<HTMLElement>,
    private tooltip: MatTooltip,
    private renderer: Renderer2,
  ) {}

  @HostListener('mouseover', ['$event.target'])
  onMouseOver(target: HTMLElement): void {
    const element = target || this.elementRef.nativeElement;
    const shouldDisplayTooltip = element != null && element.scrollWidth > 0
      ? element.scrollWidth > element.offsetWidth
      : element.parentElement.offsetWidth > 0
        ? element.parentElement.offsetWidth < element.offsetWidth
        : false;

    if (shouldDisplayTooltip) {
      this.tooltip.message = element.textContent || '';
      this.tooltip.show();
    } else {
      this.tooltip.message = '';
      this.tooltip.hide();

      // Remove any existing title attribute
      this.renderer.removeAttribute(element, 'title');
    }
  }

  @HostListener('mouseleave')
  onMouseLeave(): void {
    this.tooltip.hide();
  }
}
